import styled from "styled-components";
import { Button as ButtonCustom } from "@company-mrv/mrv-design-system/components";

export const ButtonApp = styled(ButtonCustom)`
  visibility: ${props => (props.show ? "visible" : "hidden")};
  min-width: 125px;
  max-width: 125px;
  min-height: 40px;
  max-height: 40px;
  font-size: 16px;
  width: 100%;
  border-radius: 8px;
  border-color: black;
  color: black;
  padding: 0;
  border-width: 1px;
  background-color: white;

  &:hover,
  &:focus,
  [data-whatintent="touch"] &:focus,
  [data-whatintent="mouse"] &:hover,
  [data-whatinput="keyboard"] &:focus {
    background-color: white;
    color: black;
    opacity: 0.8;
    border-color: black;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: normal;
`;

export const ImgButton = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 5px;
`;
